<!-- page header -->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Foodmarket
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home"/>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- Loading state -->
  <div *ngIf="loading" class="ion-padding ion-text-center">
    <ion-spinner></ion-spinner>
    <p>Loading data...</p>
  </div>

  <!-- Error state -->
  <ion-card *ngIf="error && !loading">
    <ion-card-content>
      <ion-text color="danger">
        <h2>{{error}}</h2>
      </ion-text>
    </ion-card-content>
  </ion-card>

  <!-- Main content -->
  <div *ngIf="!loading && !error && menuData">
    <!-- Information card with instructions and video - Prominent -->
    <ion-card color="primary">
      <ion-card-header>
        <ion-card-title>Neu: Food Market</ion-card-title>
        <ion-card-subtitle>Standort in der Cafeteria Time out (West)</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <p><strong>VERPFLEGUNG AM ARBEITSPLATZ NEU DEFINIERT</strong></p>
        <p>Coop to go - Food Market – brought to you by Selecta ist eine flexible und innovative Lösung, welche die Verpflegung am Arbeitsplatz neu definiert.</p>
        
        <!-- Embedded Video -->
        <div class="ion-margin-top">
          <h3><strong>Video: So verwenden Sie Food Market</strong></h3>
          <iframe 
            width="100%" 
            height="315" 
            src="https://www.youtube.com/embed/CNP1M-KccWY" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
            style="max-width: 560px; display: block; margin: 0 auto;">
          </iframe>
        </div>
        
        <!-- Info button -->
        <ion-button expand="block" fill="outline" color="light" href="https://www.selecta.com/ch/de/unsere-selbstbedienungsoptionen/food-market" target="_blank" class="ion-margin-top">
          <ion-icon slot="start" name="information-circle"></ion-icon>
          Mehr Informationen
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>

